import { type FilterConfig } from '../interfaces';

import { greetingFilterConfigSingle } from './default-config-single';

export const greetingFilterConfigMultiple: FilterConfig = {
  ...greetingFilterConfigSingle,
  multiple: true,
};
